import { render, staticRenderFns } from "./NewYSPlayer.vue?vue&type=template&id=3daffc0e&scoped=true"
import script from "./NewYSPlayer.vue?vue&type=script&lang=js"
export * from "./NewYSPlayer.vue?vue&type=script&lang=js"
import style0 from "./NewYSPlayer.vue?vue&type=style&index=0&id=3daffc0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3daffc0e",
  null
  
)

export default component.exports